import EntityModel from '@/common/models/entity-model';

export default class WebhookAuthorizationModel extends EntityModel {
    static Types = {
        none: 'none',
        basic: 'basic',
        digest: 'digest',
        oauth1: 'oauth1',
    };

    hydrate({
        type = WebhookAuthorizationModel.Types.none,
        username = null,
        password = null,
        consumerKey = null,
        consumerSecret = null,
        token = null,
        tokenSecret = null,
    } = {}) {
        this.type = type;
        this.username = username;
        this.password = password;
        this.consumerKey = consumerKey;
        this.consumerSecret = consumerSecret;
        this.token = token;
        this.tokenSecret = tokenSecret;
    }

    get isNoAuth() {
        return this.type === WebhookAuthorizationModel.Types.none;
    }

    get isBasicAuth() {
        return this.type === WebhookAuthorizationModel.Types.basic;
    }

    get isDigestAuth() {
        return this.type === WebhookAuthorizationModel.Types.digest;
    }

    get isOAuth1() {
        return this.type === WebhookAuthorizationModel.Types.oauth1;
    }

    getPayload() {
        let payload = {
            type: this.type,
        };
        if (WebhookAuthorizationModel.Types.none === this.type) {
            payload = {
                ...payload,
                method: this.method,
            };
        }
        if ([WebhookAuthorizationModel.Types.basic,
            WebhookAuthorizationModel.Types.digest].includes(this.type)) {
            payload = {
                ...payload,
                username: this.username,
                password: this.password,
            };
        }
        if (WebhookAuthorizationModel.Types.oauth1 === this.type) {
            payload = {
                ...payload,
                consumerkey: this.consumerkey,
                consumerSecret: this.consumerSecret,
                token: this.token,
                tokenSecret: this.tokenSecret,
            };
        }
        return payload;
    }
}
